import { service } from '@/utils/request'
import constv from '@/config/constv'

class role {
  static getList (params) { return service.get(constv.AUTH_URL + '/admin/auth_group/getAuthGroupList', { params }) }
  static add (params) { return service.post(constv.AUTH_URL + '/admin/auth_group/addAuthGroup', params) }
  static edit (id, params) { return service.post(constv.AUTH_URL + '/admin/auth_group/editAuthGroup?id=' + id, params) }
  static detail (params) { return service.get(constv.AUTH_URL + '/admin/auth_group/editAuthGroup', { params }) }
  static delete (params) { return service.get(constv.AUTH_URL + '/admin/auth_group/delAuthGroup', { params }) }
}

export default role
